export const adaptStatisticsPerAssetResponse = (response) => {
  if (!response) return buildEmpty(500)
  const status = resolveStatus(response)
  if (status !== 200) return buildEmpty(status)
  const data = extractBreakdownData(response)
  return {
    ok: true,
    status: 200,
    statistics_by_asset: mapStatisticsByAsset(data),
  }
}

const buildEmpty = (status) => ({
  ok: false,
  status,
  statistics_by_asset: {},
})

const resolveStatus = (response) => {
  const inner = response.value && response.value.status
  if (typeof inner === 'number') return inner
  return typeof response.status === 'number' ? response.status : 500
}

const extractBreakdownData = (response) => {
  const value = response.value || {}
  const breakdown = value.breakdown
  if (!breakdown || !breakdown.data) return {}
  return breakdown.data
}

const mapStatisticsByAsset = (data) => {
  const map = {}
  for (const [key, entry] of Object.entries(data)) {
    if (!entry || !entry.statistics) continue
    if (!hasMeaningfulStats(entry.statistics)) continue
    map[key] = entry.statistics
  }
  return map
}

const hasMeaningfulStats = (stats) => Object.keys(stats).length > 0
